export const STORAGE = {
    TOKEN: 'token'
}